import React from "react";
import { useLang } from "../../context/lang-context";

const LandingDelivery: React.FC = () => {
  const { t } = useLang();

  return (
    <section className="showcase-section showcase-reverse">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-md-6 text-center text-md-start order-2 order-md-1">
            <h2 className="showcase-title">
              {t("Otros manejan sólo envíos.", "Others handle just delivery.")}
            </h2>
            <h3 className="showcase-subtitle">
              {t("Nosotros no", "Not us")}
            </h3>
            <p className="showcase-text">
              {t(
                "Sabemos que no siempre necesitas envío a domicilio. Con Foo también puedes escoger tu pedido Para Llevar o Para Comer Aquí.",
                "We know delivery isn't always needed. With Foo you can also choose Takeout or Dine-In."
              )}
            </p>
          </div>
          <div className="col-10 col-md-5 text-center mb-4 mb-md-0 order-1 order-md-2">
            <img
              src="/img/iPhone-foo-screen-4@0.5x.png"
              alt={t("Opciones de entrega", "Delivery options")}
              className="showcase-phone"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingDelivery;
